'use strict';

var util = require('./util'),
    bonusProductsView = require('./bonus-products-view'),
    bornModules = require('./helpers/born.modules').default;

var timer = {
    id: null,
    clear: function () {
        if (this.id) {
            window.clearTimeout(this.id);
            delete this.id;
        }
    },
    start: function (duration, callback) {
        this.id = setTimeout(callback, duration);
    }
};

function refreshMiniCart() {
    return new Promise((resolve) => {
        $.ajax({
            url: Urls.miniCartShow,
            type: 'GET'
        }).done(function (response) {
            	minicart.updateContent(response);
        }).fail(function () {
            page.refresh();
        }).always(function () {
            resolve();
        });
    });
}

var minicart = {
	init: function () {
        this.$el = $('#mini-cart');
        var isApiCalled = false;
        this.$content = this.$el.find('.minicart__content');
    	$('#headerMinicartLink').hover(function(e) {
    		if (!isApiCalled) {
    			refreshMiniCart();
    			isApiCalled = true;
    		}
        }, function(){
            //This function is for unhover.
        	isApiCalled = false;
        }); 
        $('#headerMinicartLink, #mobileHeaderMinicartLink, #minicartview, .minicart__link--cart').click(function(e) {
            moengageGoToBagEvent("go_to_bag");
        });
    	this.updateMinicartCheckout();

    },
    /**
     * @function
     * @description Shows the given content in the mini cart
     * @param {String} A HTML string with the content which will be shown
     */
    show: function (html, showMinicartPopup = true) {
        this.replaceContent(html, showMinicartPopup);
        if(showMinicartPopup) {
            this.slide();
        }
        this.updateMinicartCheckout();
    },
    /**
     * @function
     * @description Replaces the given content in the mini cart
     * @param {String} A HTML string with the content which will be placed in minicart content
     */
    replaceContent: function (html) {
        this.$el.html(html);
        this.init();
        bornModules.toggle.init();
        bornModules.overlayToggle.init();
        bornModules.cancelScroll.init();
        bonusProductsView.loadBonusOption();
        this.updateMinicartCheckout();
    },
    
    updateContent : function (html) {
    	this.$el = $('#mini-cart');
    	var parseHTML = $.parseHTML(html);
    	var content = $(parseHTML).filter('.minicart__content');
        $('#mini-cart .minicart__content').html(content.html());
        this.updateMinicartCheckout();
    },
    /**
     * @function
     * @description Slides down and show the contents of the mini cart
     */
    slide: function () {
        timer.clear();
        // show the item
        this.$content[0].showContent();
        // after a time out automatically close it
        timer.start(5000, this.close.bind(this));

        this.$content.on('mouseenter.toggled', timer.clear.bind(timer));
    },
    /**
     * @function
     * @description Closes the mini cart
     */
    close: function () {
        timer.clear();
        this.$content[0].hideContent();
    },
    updateMinicartCheckout:function(e) {
        $('#minicartview').click(function(e) {
            var user=dataLayer.find(o => o.user != null).user;
            dataLayer.push({
                "event": 'custom_event',
                "eventCategory": 'bag_popup',
                "eventAction": 'popup_view_shopping_bag',
                "eventLabel": 'popup view shopping bag click',
                "country": window.GlobalAttributes.COUNTRY,
                "language": window.GlobalAttributes.LANGUAGE,
                "screenName" : 'Bag Popup',
                "userType": user.user_id!='' ? 'logged-in' : 'logged-out',
                "userId": user.user_id!='' ? user.user_id : ''
            });
        })
    	if($("#begin-checkout-minicart").length > 0) {
    		$("#begin-checkout-minicart").on('click', function(e) {
                var user=dataLayer.find(o => o.user != null).user;
                dataLayer.push({
                    "event": 'custom_event',
                    "eventCategory": 'bag_popup',
                    "eventAction": 'popup_proceed_to_checkout',
                    "eventLabel": 'popup proceed to checkout click',
                    "country": window.GlobalAttributes.COUNTRY,
                    "language": window.GlobalAttributes.LANGUAGE,
                    "screenName" : 'Bag Popup',
                    "userType": user.user_id!='' ? 'logged-in' : 'logged-out',
                    "userId": user.user_id!='' ? user.user_id : ''
                });
    			e.preventDefault();
        		var cartId = $(this).data('value');
        		moengagecheckoutPushEvent(cartId);
        		window.location = $(this).attr('href');
    		});
    	} 
    }
};

module.exports = minicart;



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/minicart.js